module.exports = __webpack_public_path__ + "static/media/clock.aaefb6db.png";